<ng-container
  *ngIf="{
    isCompact: isCompact$ | async,
  } as content"
>
  <div class="container-toggle-list-view">
    <simple-toggle
      [checked]="content?.isCompact === true"
      label="productView.viewMode"
      [invertLabel]="true"
      (callbackOnChange)="changeViewMode($event)"
    ></simple-toggle>
  </div>
</ng-container>
